import * as S from "./styles";

function Gallery({items}) {
  return (
    <S.GalleryContainer>
      <S.MiniTitle id="solutionsHome">Our Solutions</S.MiniTitle>
      <S.Title>Creating a cleaner, healthier future.</S.Title>
      <S.Grid>
        {items.map((item, index) => (
          <S.Card key={index}>
            <S.Image src={item.src} alt={item.alt} />
            <S.TitleOverlay>{item.alt}</S.TitleOverlay>
            <S.HoverOverlay>
              <S.Text>{item.alt}</S.Text>
              <S.Description>{item.description}</S.Description>
              <S.KnowMore href={item.link || "#"}>Know more</S.KnowMore>
            </S.HoverOverlay>
          </S.Card>
        ))}
      </S.Grid>
    </S.GalleryContainer>
  );
}

export default Gallery;
